module.exports = __webpack_public_path__ + "img/img19.99cb1df5.png";